import React from "react";
import EditableElement from "./EditableElement";

const EditableText = ({ text, isActive, onSetActive, onUpdate, onRemove }) => {
  return (
    <EditableElement
      element={{
        id: text.id,
        type: "text",
        text: text.content,
        width: text.width,
        height: text.height,
        position: text.position,
        rotation: text.rotation,
        fontSize: text.fontSize,
        color: text.color,
        fontFamily: text.fontFamily,
        fontWeight: text.fontWeight,
        backgroundColor: text.backgroundColor,
      }}
      isActive={isActive}
      onSetActive={onSetActive}
      onUpdate={onUpdate}
      onRemove={onRemove}
    />
  );
};

export default EditableText;
